/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const generateSharedData = /* GraphQL */ `
  query GenerateSharedData(
    $recipe: AWSJSON!
    $userInput: AWSJSON!
    $productInfo: AWSJSON!
    $state: States!
    $downloadSd: Boolean
  ) {
    generateSharedData(
      recipe: $recipe
      userInput: $userInput
      productInfo: $productInfo
      state: $state
      downloadSd: $downloadSd
    )
  }
`;
export const sendEmailNotification = /* GraphQL */ `
  query SendEmailNotification(
    $emails: [String]!
    $templateId: String!
    $templateData: AWSJSON!
  ) {
    sendEmailNotification(
      emails: $emails
      templateId: $templateId
      templateData: $templateData
    ) {
      status
      __typename
    }
  }
`;
export const getProductFilterFieldList = /* GraphQL */ `
  query GetProductFilterFieldList {
    getProductFilterFieldList {
      Category
      SubCategory
      ControlId
      ControlType
      Recipe
      CategorySubcategories {
        category
        subcategories
        __typename
      }
      Total
      __typename
    }
  }
`;
export const deploySharedDataToSystems = /* GraphQL */ `
  query DeploySharedDataToSystems(
    $systems: [String!]
    $recipe: AWSJSON!
    $userInput: AWSJSON!
    $state: String!
    $productInfo: AWSJSON!
  ) {
    deploySharedDataToSystems(
      systems: $systems
      recipe: $recipe
      userInput: $userInput
      state: $state
      productInfo: $productInfo
    ) {
      status
      __typename
    }
  }
`;
export const insertSdpAmsData = /* GraphQL */ `
  query InsertSdpAmsData(
    $productInfo: AWSJSON!
    $recipe: AWSJSON!
    $userInput: AWSJSON!
    $state: String!
    $downloadSd: Boolean!
  ) {
    insertSdpAmsData(
      productInfo: $productInfo
      recipe: $recipe
      userInput: $userInput
      state: $state
      downloadSd: $downloadSd
    )
  }
`;
export const generateAmsData = /* GraphQL */ `
  query GenerateAmsData(
    $productInfo: AWSJSON!
    $recipe: AWSJSON!
    $userInput: AWSJSON!
    $state: String!
    $downloadSd: Boolean!
  ) {
    generateAmsData(
      productInfo: $productInfo
      recipe: $recipe
      userInput: $userInput
      state: $state
      downloadSd: $downloadSd
    )
  }
`;
export const generateCoolCloudData = /* GraphQL */ `
  query GenerateCoolCloudData(
    $productInfo: AWSJSON!
    $recipe: AWSJSON!
    $userInput: AWSJSON!
    $state: String!
    $downloadSd: Boolean!
    $accessToken: String
  ) {
    generateCoolCloudData(
      productInfo: $productInfo
      recipe: $recipe
      userInput: $userInput
      state: $state
      downloadSd: $downloadSd
      accessToken: $accessToken
    )
  }
`;
export const manageEmailSesIdentity = /* GraphQL */ `
  query ManageEmailSesIdentity($identity: String!, $action: String!) {
    manageEmailSesIdentity(identity: $identity, action: $action) {
      message
      __typename
    }
  }
`;
export const searchProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: [SearchableProductSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductAggregationInput]
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        ModelNumber
        Family
        Category
        SubCategory
        ControlId
        ControlType
        BtEnabled
        SdAvailable
        State
        Recipe
        RecipeDescription
        StagingVersion
        ProductionVersion
        CloneFromProductId
        AMSAck
        CoolCloudDBAck
        ShareddataVersion
        SoftwareVersion
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const searchActionItems = /* GraphQL */ `
  query SearchActionItems(
    $filter: SearchableActionItemsFilterInput
    $sort: [SearchableActionItemsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableActionItemsAggregationInput]
  ) {
    searchActionItems(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        ModelNumber
        Family
        Category
        SubCategory
        ControlId
        ControlType
        BtEnabled
        SdAvailable
        State
        Recipe
        RecipeDescription
        StagingVersion
        ProductionVersion
        ReviewerEmail
        ReviewerEmails
        CreatedByEmail
        CreationDate
        LastUpdate
        Status
        ProductId
        Input
        Version
        ReasonForChange
        CloneFromProductId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getSdpUser = /* GraphQL */ `
  query GetSdpUser($Email: String!) {
    getSdpUser(Email: $Email) {
      id
      Name
      Email
      Role
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSdpUsers = /* GraphQL */ `
  query ListSdpUsers(
    $Email: String
    $filter: ModelSdpUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSdpUsers(
      Email: $Email
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        Name
        Email
        Role
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSdpRecipe = /* GraphQL */ `
  query GetSdpRecipe($Name: String!) {
    getSdpRecipe(Name: $Name) {
      id
      Name
      Recipe
      Description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSdpRecipes = /* GraphQL */ `
  query ListSdpRecipes(
    $Name: String
    $filter: ModelSdpRecipeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSdpRecipes(
      Name: $Name
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        Name
        Recipe
        Description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSdpRecipeInput = /* GraphQL */ `
  query GetSdpRecipeInput($id: ID!, $ModelNumber: String!) {
    getSdpRecipeInput(id: $id, ModelNumber: $ModelNumber) {
      id
      ModelNumber
      Input
      State
      Version
      ReasonForChange
      ExpiryDays
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSdpRecipeInputs = /* GraphQL */ `
  query ListSdpRecipeInputs(
    $id: ID
    $ModelNumber: ModelStringKeyConditionInput
    $filter: ModelSdpRecipeInputFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSdpRecipeInputs(
      id: $id
      ModelNumber: $ModelNumber
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        ModelNumber
        Input
        State
        Version
        ReasonForChange
        ExpiryDays
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!, $ModelNumber: String!) {
    getProduct(id: $id, ModelNumber: $ModelNumber) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      CloneFromProductId
      AMSAck
      CoolCloudDBAck
      ShareddataVersion
      SoftwareVersion
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $id: ID
    $ModelNumber: ModelStringKeyConditionInput
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listProducts(
      id: $id
      ModelNumber: $ModelNumber
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        ModelNumber
        Family
        Category
        SubCategory
        ControlId
        ControlType
        BtEnabled
        SdAvailable
        State
        Recipe
        RecipeDescription
        StagingVersion
        ProductionVersion
        CloneFromProductId
        AMSAck
        CoolCloudDBAck
        ShareddataVersion
        SoftwareVersion
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLookupOption = /* GraphQL */ `
  query GetLookupOption($id: ID!, $Name: String!) {
    getLookupOption(id: $id, Name: $Name) {
      id
      Name
      Options
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLookupOptions = /* GraphQL */ `
  query ListLookupOptions(
    $id: ID
    $Name: ModelStringKeyConditionInput
    $filter: ModelLookupOptionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLookupOptions(
      id: $id
      Name: $Name
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        Name
        Options
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActionItems = /* GraphQL */ `
  query GetActionItems($id: ID!) {
    getActionItems(id: $id) {
      id
      ModelNumber
      Family
      Category
      SubCategory
      ControlId
      ControlType
      BtEnabled
      SdAvailable
      State
      Recipe
      RecipeDescription
      StagingVersion
      ProductionVersion
      ReviewerEmail
      ReviewerEmails
      CreatedByEmail
      CreationDate
      LastUpdate
      Status
      ProductId
      Input
      Version
      ReasonForChange
      CloneFromProductId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listActionItems = /* GraphQL */ `
  query ListActionItems(
    $filter: ModelActionItemsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActionItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ModelNumber
        Family
        Category
        SubCategory
        ControlId
        ControlType
        BtEnabled
        SdAvailable
        State
        Recipe
        RecipeDescription
        StagingVersion
        ProductionVersion
        ReviewerEmail
        ReviewerEmails
        CreatedByEmail
        CreationDate
        LastUpdate
        Status
        ProductId
        Input
        Version
        ReasonForChange
        CloneFromProductId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($commentId: ID!, $date: AWSDateTime!) {
    getComment(commentId: $commentId, date: $date) {
      commentId
      name
      date
      text
      parent_comment_id
      property_name
      actionId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $commentId: ID
    $date: ModelStringKeyConditionInput
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listComments(
      commentId: $commentId
      date: $date
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        commentId
        name
        date
        text
        parent_comment_id
        property_name
        actionId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSdpCoolCloudData = /* GraphQL */ `
  query GetSdpCoolCloudData($id: ID!, $model_number: String!) {
    getSdpCoolCloudData(id: $id, model_number: $model_number) {
      id
      control_id
      createdAt
      createdTime
      deleted
      display_value
      first_part
      last_part
      middle_part
      model_number
      second_part
      shareddata_version
      software_version
      updatedAt
      updatedTime
      _lastChangedAt
      _version
      __typename
      __typename
    }
  }
`;
export const listSdpCoolCloudData = /* GraphQL */ `
  query ListSdpCoolCloudData(
    $id: ID
    $model_number: ModelStringKeyConditionInput
    $filter: ModelSdpCoolCloudDataFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSdpCoolCloudData(
      id: $id
      model_number: $model_number
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        control_id
        createdAt
        createdTime
        deleted
        display_value
        first_part
        last_part
        middle_part
        model_number
        second_part
        shareddata_version
        software_version
        updatedAt
        updatedTime
        _lastChangedAt
        _version
        __typename
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSdpAmsData = /* GraphQL */ `
  query GetSdpAmsData($RecipeName: String!) {
    getSdpAmsData(RecipeName: $RecipeName) {
      id
      RecipeName
      Type
      ModelNum
      Revision
      params
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSdpAmsData = /* GraphQL */ `
  query ListSdpAmsData(
    $RecipeName: String
    $filter: ModelSdpAmsDataFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSdpAmsData(
      RecipeName: $RecipeName
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        RecipeName
        Type
        ModelNum
        Revision
        params
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSdpAutoDeleteSchedule = /* GraphQL */ `
  query GetSdpAutoDeleteSchedule($id: ID!) {
    getSdpAutoDeleteSchedule(id: $id) {
      id
      temp_model_number
      actual_model_number
      expiry_days
      expiry_date
      created_by
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSdpAutoDeleteSchedules = /* GraphQL */ `
  query ListSdpAutoDeleteSchedules(
    $id: ID
    $filter: ModelSdpAutoDeleteScheduleFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSdpAutoDeleteSchedules(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        temp_model_number
        actual_model_number
        expiry_days
        expiry_date
        created_by
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listModelNumberByState = /* GraphQL */ `
  query ListModelNumberByState(
    $ModelNumber: String!
    $State: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSdpRecipeInputFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listModelNumberByState(
      ModelNumber: $ModelNumber
      State: $State
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ModelNumber
        Input
        State
        Version
        ReasonForChange
        ExpiryDays
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDataByModelNumber = /* GraphQL */ `
  query ListDataByModelNumber(
    $id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSdpCoolCloudDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataByModelNumber(
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        control_id
        createdAt
        createdTime
        deleted
        display_value
        first_part
        last_part
        middle_part
        model_number
        second_part
        shareddata_version
        software_version
        updatedAt
        updatedTime
        _lastChangedAt
        _version
        __typename
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getScheduleByTempModelNumber = /* GraphQL */ `
  query GetScheduleByTempModelNumber(
    $temp_model_number: String!
    $sortDirection: ModelSortDirection
    $filter: ModelSdpAutoDeleteScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getScheduleByTempModelNumber(
      temp_model_number: $temp_model_number
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        temp_model_number
        actual_model_number
        expiry_days
        expiry_date
        created_by
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
